import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "../../.././../typings/theme";

export const CardWrapper = styled.div`
  ${({ theme }: NectarTheme) => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.md};
  `}
`;

export const CounterContainer = styled.div`
  ${({ theme }: NectarTheme) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: ${theme.spacings.lg} 0;

    ${theme.breakpoints.sm} {
      flex-direction: row;
      gap: 0 ${theme.spacings.lg};
    }
  `}
`;
